import TurndownService from 'turndown'

/**
 * 共享的 HTML → Markdown 转换器。
 *
 * 单独放在 utils 而不是挂在 `@/components/ui/tiptap-editor` 上：转换器本身与富文本
 * 编辑器无关，但 tiptap-editor 会连带 `@tiptap/*` + `lowlight`（几十种语法高亮语言）
 * 一起进包。KB feed 的 EditableBody 只需要转换器，从编辑器 import 会把整个编辑器
 * 拖进 KB 路由分包。
 */
const createTurndownService = () =>
  new TurndownService({
    headingStyle: 'atx',
    codeBlockStyle: 'fenced',
    bulletListMarker: '-',
  })

// turndown 是无状态转换器，可以全局复用 —— onUpdate 每敲一个键都会跑，
// 原来每次 new 一个实例（含全部规则注册）纯属浪费。
let sharedTurndown: TurndownService | null = null

export const getTurndownService = () => (sharedTurndown ??= createTurndownService())
